/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import Text from '../Text'
import colors from '@sportninja/common/constants/appColors'
import { Select, Tag } from 'antd'
import { paragraphSmall } from 'src/components/css'
import { ErrorLabel } from '../ErrorLabel'
import PencilIcon from '../../icons/PencilIcon'

type DisplayedStandingsInputProps = {
  label: string
  options: { label: string; value: string }[]
  value: string[]
  onChange: (value: string[]) => void
  fieldErrors: string[]
  customError: any
  name: string
}

const DisplayedStandingsInput = ({
  label,
  options,
  value,
  onChange,
  fieldErrors,
  customError,
  name,
}: DisplayedStandingsInputProps) => {
  const tagRender = (props: any) => {
    const { label: tagLabel, value: tagValue } = props

    // Find the order/index of this value in the current value array
    const order = value.indexOf(tagValue) + 1

    return (
      <Tag
        closable={false} // Remove the X button
        style={{
          backgroundColor: colors.PRIMARY,
          color: colors.SECONDARY_300,
          border: 'none',
          padding: '4px 8px',
          fontSize: '14px',
          lineHeight: '20px',
        }}
      >
        {order}. {tagLabel}
      </Tag>
    )
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
      `}
    >
      {label && (
        <Text variant='paragraphSmall' weight='regular' color={colors.WHITE}>
          {label}
        </Text>
      )}
      <Select
        mode='multiple'
        options={options}
        value={value}
        onChange={onChange}
        tagRender={tagRender}
        suffixIcon={<PencilIcon />}
        getPopupContainer={(triggerNode) =>
          triggerNode.parentElement || document.body
        }
        css={css`
          width: 100%;
          .ant-select-selector {
            padding: 4px !important;
            line-height: 1.5 !important;
          }
          .ant-select-selection-overflow {
            gap: 0px !important;
          }
          .ant-select-selection-overflow-item {
            margin-bottom: 4px !important;
            margin-top: 4px !important;
          }
          .ant-select-selection-item-content {
            ${paragraphSmall}
            align-self: center;
            color: ${colors.SECONDARY_300};
          }
          .ant-select-selection-item {
            background-color: ${colors.PRIMARY}!important;
            padding: 4px 8px !important;
            margin: 0 !important;
          }
          .ant-select-selection-item-remove {
            color: ${colors.SECONDARY_300}!important;
          }
          /* Show the suffix icon by removing display: none */
          .ant-select-arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${colors.SECONDARY_300};
          }
        `}
        status={fieldErrors[name] || fieldErrors?.includes(name) ? 'error' : ''}
      />
      <ErrorLabel
        fieldErrors={fieldErrors || []}
        customError={customError || ''}
        name={name}
      />
    </div>
  )
}

export default DisplayedStandingsInput
